"use client";

import { useState } from "react";
import { login } from "./actions";

const FONT = { fontFamily: "var(--font-geist-sans), system-ui, sans-serif" };
const MONO = { fontFamily: "var(--font-geist-mono), monospace" };

export function LoginForm() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(false);
    const res = await login(pw);
    if (res.ok) {
      // Hard navigation guarantees the freshly set cookie is sent (mobile Safari
      // can skip it on a soft router.refresh).
      window.location.href = "/studio";
    } else {
      setBusy(false);
      setErr(true);
    }
  }

  return (
    <main
      style={FONT}
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#080808] text-white"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/3 h-[50vh] w-[50vh] rounded-full bg-[#ee4f27] opacity-20 blur-[160px]" />
        <div className="absolute right-1/4 top-20 h-[45vh] w-[45vh] rounded-full bg-[#9c40ff] opacity-20 blur-[160px]" />
      </div>

      <form onSubmit={submit} className="relative w-full max-w-sm px-6 text-center">
        <div style={MONO} className="mb-3 text-[0.7rem] tracking-[0.4em] text-white/40">
          FORMED · DEMO STUDIO
        </div>
        <h1 className="mb-8 text-2xl font-medium">
          <span className="bg-gradient-to-r from-[#ff6a3d] to-[#9c40ff] bg-clip-text text-transparent">
            Anmeldung
          </span>
        </h1>
        <input
          type="password"
          autoFocus
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="Passwort"
          className="w-full rounded-lg border border-white/10 bg-black/40 px-4 py-3 text-center text-white outline-none placeholder:text-white/30 focus:border-[#9c40ff]/60"
        />
        {err && <p className="mt-3 text-sm text-red-300">Falsches Passwort</p>}
        <button
          type="submit"
          disabled={busy}
          className="mt-4 w-full rounded-lg bg-gradient-to-r from-[#ee4f27] to-[#9c40ff] px-6 py-3 font-medium text-white transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {busy ? "…" : "Eintreten"}
        </button>
      </form>
    </main>
  );
}
